module.exports = __webpack_public_path__ + "img/gold.3c9e77ae.svg";